import * as React from 'react';
import { useUI } from '../contexts/UIProvider';
import CheckIcon from './icons/CheckIcon';

const { useState, useEffect } = React;

const Toast: React.FC = () => {
    const { toast } = useUI();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (toast) {
            setVisible(true);
            const timer = setTimeout(() => {
                setVisible(false);
            }, 2800); // A bit shorter than the clear timeout in provider to allow for fade-out
            return () => clearTimeout(timer);
        }
    }, [toast]);

    return (
        <div 
            className={`fixed bottom-24 md:bottom-5 left-1/2 -translate-x-1/2 bg-green-500 text-white px-6 py-3 rounded-full shadow-lg transition-all duration-300 ease-in-out ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5 pointer-events-none'
            }`}
            role="alert"
            aria-live="assertive"
        >
            <div className="flex items-center space-x-2">
                <CheckIcon className="h-5 w-5" />
                <span className="font-semibold">{toast}</span>
            </div>
        </div>
    );
};

export default Toast;